"use client";

import type { ConnectionStatus } from "@/lib/api/types";

import { useShell } from "./shell-context";

// Der Status steht als Text, die Farbe ist nur Zusatz
const STATES: Record<ConnectionStatus, { label: string; className: string }> = {
  connected: { label: "verbunden", className: "text-nav-ok" },
  warning: { label: "Warnung", className: "text-nav-warn" },
  error: { label: "Fehler", className: "text-nav-danger" },
  untested: { label: "nicht getestet", className: "text-nav-muted" },
  not_connected: { label: "nicht verbunden", className: "text-nav-muted" },
};

export function SourceStatus() {
  const { connections, connectionsFailed } = useShell();

  return (
    <div className="flex flex-col gap-2">
      <h2 className="px-3 pb-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-nav-muted">
        Datenquellen
      </h2>
      {connections === null ? (
        <p className={`px-3 text-[13px] ${connectionsFailed ? "text-nav-danger" : "text-nav-muted"}`}>
          {connectionsFailed ? "Status nicht abrufbar" : "Wird geladen …"}
        </p>
      ) : (
        <ul aria-label="Status der Datenquellen" className="flex flex-col gap-2">
          {connections.map((connection) => {
            const state = STATES[connection.status];
            return (
              <li key={connection.source} className="flex items-center justify-between px-3 text-[13px]">
                <span>{connection.name}</span>
                <span className={`text-xs ${state.className}`}>{state.label}</span>
              </li>
            );
          })}
        </ul>
      )}
      {connections !== null && connectionsFailed && (
        <p role="status" className="px-3 text-xs text-nav-danger">
          Aktualisierung fehlgeschlagen, Stand evtl. veraltet
        </p>
      )}
    </div>
  );
}
